import { render, staticRenderFns } from "./HomeCliente.vue?vue&type=template&id=0be888cf&"
import script from "./HomeCliente.vue?vue&type=script&lang=js&"
export * from "./HomeCliente.vue?vue&type=script&lang=js&"
import style0 from "./HomeCliente.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports